import { memo, useCallback } from "react";

import exportTable from "@/react/components/table/exportTable";
import { StyledDownloadIcon } from "@/react/components/styled/StyledIcons";

import { convertToCsv } from "./csvSerializer";
import { FlexPointerContainer } from "./styled";

const DownloadCsv = ({ title, columns, rows }) => {
  const onDownloadCsv = useCallback(() => {
    convertToCsv(title, exportTable(columns, rows));
  }, [columns, rows]);

  return (
    <FlexPointerContainer onClick={onDownloadCsv}>
      <StyledDownloadIcon />
      <span>Download CSV</span>
    </FlexPointerContainer>
  );
};

export default memo(DownloadCsv);
